import React from 'react';
import classes from './Spinner.scss';

const spinner = () => (
    <div className={classes.Ripple}><div></div><div></div></div>
);

export default spinner;


// WEBPACK FOOTER //
// ./src/components/UI/Spinner/Spinner.js